import React from 'react'
import AssignProcessContainer from '../../containers/admin_portal/assigntoprocess/AssignProcessContainer';

const AssignProcessPage = () => {
  return (
    <div>
      <AssignProcessContainer />
    </div>
  )
}

export default AssignProcessPage;
